import $ from "jquery";
import _ from "underscore";

("use strict");

const UIHelper = {
	updateAccessElements: (hasPremium) => {
		if (hasPremium) {
			$(".requires-premium").show();
			$(".hidden-premium").hide();
			$("body").addClass("is-premium");
		} else {
			$(".requires-premium").hide();
			$(".hidden-premium").show();
			$("body").removeClass("is-premium");
		}
	},

	setupRemoteModals: () => {
		$(".remote-modal").on("show.bs.modal", function (e) {
			$(this)
				.find(".modal-text")
				.load(e.relatedTarget.href + " .main-content");
		});
	},

	setupDates: () => {
		$("#year").html(window.moment().format("YYYY"));
	},

	listenForFullscreen: () => {
		$(document).on(
			"fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange",
			(event) => {
				const el =
					document.fullscreenElement ||
					document.webkitFullscreenElement ||
					document.mozFullScreenElement ||
					document.msFullscreenElement;
				if (
					el &&
					el.id === "skysafariContainer" &&
					(document.fullscreen ||
						document.webkitIsFullScreen ||
						document.mozFullScreen)
				) {
					// is fullscreen so add class to body
					$("body").addClass("ssww-fullscreen");
				} else {
					// is not fullscreen so remove class from body
					$("body").removeClass("ssww-fullscreen");
				}
			},
		);
	},

	showParseError: () => {
		$(".system-error").removeAttr("hidden");
	},

	hideLoading: () => {
		const loader = document.getElementById("app-loading");
		if (loader) {
			loader.classList.add("loaded");
			setTimeout(() => loader.remove(), 300);
		}
	},

	showContent: () => {
		UIHelper.hideLoading();
		$(".account-nav").removeAttr("hidden");
		$(".app-body").removeAttr("hidden");
		$(".app-footer").removeAttr("hidden");
	},
};

export default UIHelper;
